"use client";
import React from "react";
import Head from "next/head";

const SeoHead = ({ topNeighborhood, loading }) => {
  const cityName =
    !loading && topNeighborhood?.length > 0
      ? `${topNeighborhood[0].postalcity_name}, ${topNeighborhood[0].state_name}`
      : "City";

  // derive slug (for dynamic meta description)
  const slug =
    typeof window !== "undefined"
      ? window.location.href.replace(/\/$/, "").split("/").pop()
      : "";

  const metaDescription = `Learn about ${
    !loading && topNeighborhood?.length > 0 ? slug || cityName : "City"
  } on Houseberry. Get comprehensive city insights, scores on schools, safety, and amenities. Explore neighborhood rankings, and real estate home listings.`;

  const metaKeywords = `${
    !loading && topNeighborhood?.length > 0 ? slug || cityName : "City"
  }, neighborhoods, real estate, schools, safety scores, values`;

  return (
    <Head>
      {/* External CSS */}
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      <link
        rel="stylesheet"
        href="https://unpkg.com/react-rangeslider/umd/rangeslider.min.css"
      />

      {/* Dynamic SEO */}
      <title>{cityName}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta
        property="og:image"
        content={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/seoimg.png`}
      />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </Head>
  );
};

export default SeoHead;
